"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dropdown = void 0;
var react_1 = __importStar(require("react"));
var react_select_1 = __importStar(require("react-select"));
var constants_1 = require("../../../constants");
var colors_1 = require("../../../constants/colors");
var icons_1 = require("../../../constants/icons");
var mixpanel_events_1 = require("../../../constants/mixpanel-events");
var dropdown_1 = require("../../../types/dropdown");
var atoms_1 = require("../../atoms");
var molecules_1 = require("../../molecules");
var SELECT_ALL_OPTION = { label: 'Select All', value: 'select_all' };
var ACTIONS = {
    SELECT_OPTION: 'select-option',
    DESELECT_OPTION: 'deselect-option',
    REMOVE_VALUE: 'remove-value',
    POP_VALUE: 'pop-value',
};
var DRODPWN_SIZE_STYLES = (_a = {},
    _a[dropdown_1.DROPDOWN_SIZE_TYPES.LARGE] = {
        customStyles: {
            control: {
                borderRadius: '5px',
                padding: '21px 24px',
                minHeight: '72px',
            },
            option: {
                height: '64px',
            },
            menu: {
                borderRadius: '10px',
            },
            input: {},
            valueContainer: {},
        },
        dropdownIndicatorProps: {
            width: 24,
            height: 24,
        },
        menuOptionClasses: {
            wrapperClass: 'tw-p-2 tw-h-16',
            containerClass: 'tw-rounded-2.5',
            labelOverrideClassName: 'f-16-400',
            contentWrapper: 'tw-pl-2 tw-py-3 tw-w-full',
        },
        customClassNames: {
            placeholder: 'f-16-300',
        },
    },
    _a[dropdown_1.DROPDOWN_SIZE_TYPES.MEDIUM] = {
        customStyles: {
            control: {
                borderRadius: '5px',
                padding: '6px 24px',
                minHeight: '50px',
            },
            option: {
                height: '64px',
            },
            menu: {
                borderRadius: '10px',
            },
            input: {},
            valueContainer: {},
        },
        dropdownIndicatorProps: {
            width: 20,
            height: 20,
        },
        menuOptionClasses: {
            wrapperClass: 'tw-p-2 tw-h-16',
            containerClass: 'tw-rounded-2.5',
            labelOverrideClassName: 'f-16-400',
            contentWrapper: 'tw-pl-2 tw-py-3 tw-w-full',
        },
        customClassNames: {
            placeholder: 'f-16-300',
        },
    },
    _a[dropdown_1.DROPDOWN_SIZE_TYPES.SMALL] = {
        customStyles: {
            control: {
                borderRadius: '5px',
                padding: '7px 24px',
                minHeight: '44px',
            },
            option: {
                height: '64px',
            },
            menu: {
                borderRadius: '10px',
            },
            input: {},
            valueContainer: {},
        },
        dropdownIndicatorProps: {
            width: 16,
            height: 16,
        },
        menuOptionClasses: {
            wrapperClass: 'tw-p-2 tw-h-16',
            containerClass: 'tw-rounded-2.5',
            labelOverrideClassName: 'f-16-400',
            contentWrapper: 'tw-pl-2 tw-py-3 tw-w-full',
        },
        customClassNames: {
            placeholder: 'f-16-300',
        },
    },
    _a[dropdown_1.DROPDOWN_SIZE_TYPES.SMALLEST] = {
        customStyles: {
            control: {
                borderRadius: '4px',
                padding: '4.5px 8px',
                minHeight: '35px',
            },
            option: {
                height: '48px',
            },
            menu: {
                borderRadius: '4px',
            },
            input: {},
            valueContainer: {},
        },
        dropdownIndicatorProps: {
            width: 12,
            height: 12,
        },
        menuOptionClasses: {
            wrapperClass: 'tw-h-12',
            containerClass: 'tw-rounded',
            labelOverrideClassName: 'f-12-300',
            contentWrapper: 'tw-pl-2 tw-py-3 tw-w-full',
        },
        customClassNames: {
            placeholder: 'f-16-300',
        },
    },
    _a[dropdown_1.DROPDOWN_SIZE_TYPES.XSMALL] = {
        customStyles: {
            control: {
                borderRadius: '4px',
                padding: '0px 8px',
                minHeight: '27px',
            },
            option: {
                height: '30px',
            },
            menu: {
                borderRadius: '4px',
            },
            input: {
                fontSize: 12,
                fontWeight: 300,
            },
            valueContainer: {
                minHeight: '25px',
            },
        },
        dropdownIndicatorProps: {
            width: 12,
            height: 12,
        },
        menuOptionClasses: {
            wrapperClass: 'tw-h-[30px]',
            containerClass: 'tw-rounded',
            labelOverrideClassName: 'f-12-300',
            contentWrapper: '!tw-p-2 tw-w-full',
        },
        customClassNames: {
            placeholder: 'f-12-300',
        },
    },
    _a);
var CustomDropdownIndicator = function (props) {
    var _a = props.selectProps, selectProps = _a === void 0 ? {} : _a;
    // @ts-ignore selectProps contains all props passed to react select. It's passed to each child component of react-select and takes custom props as well.
    var size = selectProps.size;
    return (react_1.default.createElement(react_select_1.components.DropdownIndicator, __assign({}, props),
        react_1.default.createElement(molecules_1.SvgSpriteLoader, { id: 'chevron-down', iconCategory: icons_1.ICON_SPRITE_TYPES.ARROWS, width: DRODPWN_SIZE_STYLES[size].dropdownIndicatorProps.width, height: DRODPWN_SIZE_STYLES[size].dropdownIndicatorProps.height, color: colors_1.COLORS.TEXT_PRIMARY })));
};
var Dropdown = function (_a) {
    var _b = _a.options, options = _b === void 0 ? [] : _b, onChange = _a.onChange, _c = _a.showLabel, showLabel = _c === void 0 ? false : _c, _d = _a.wrapperClass, wrapperClass = _d === void 0 ? 'tw-w-full' : _d, labelProps = _a.labelProps, _e = _a.selectFieldWrapperClass, selectFieldWrapperClass = _e === void 0 ? 'tw-w-full tw-my-3' : _e, _f = _a.error, error = _f === void 0 ? false : _f, _g = _a.errorColor, errorColor = _g === void 0 ? colors_1.COLORS.RED_SECONDARY : _g, _h = _a.placeholder, placeholder = _h === void 0 ? '' : _h, _j = _a.noOptionsText, noOptionsText = _j === void 0 ? 'No options found' : _j, customStyles = _a.customStyles, customClassNames = _a.customClassNames, _k = _a.isMulti, isMulti = _k === void 0 ? false : _k, _l = _a.menuOptionClasses, menuOptionClasses = _l === void 0 ? {
        wrapperClass: 'tw-flex tw-items-center',
        containerClass: 'hover:tw-bg-BASE_SECONDARY',
        labelOverrideClassName: '',
    } : _l, spriteSelectedIcon = _a.spriteSelectedIcon, _m = _a.selectedIcon, selectedIcon = _m === void 0 ? (react_1.default.createElement(molecules_1.SvgSpriteLoader, { id: 'check', iconCategory: icons_1.ICON_SPRITE_TYPES.GENERAL, width: 20, height: 20, color: colors_1.COLORS.GREEN_SECONDARY })) : _m, _o = _a.isSearchable, isSearchable = _o === void 0 ? true : _o, _p = _a.spriteSelectedIconColor, spriteSelectedIconColor = _p === void 0 ? colors_1.COLORS.GREEN_SECONDARY : _p, _q = _a.showSupporterInfo, showSupporterInfo = _q === void 0 ? false : _q, _r = _a.supporterInfoProps, supporterInfoProps = _r === void 0 ? {} : _r, _s = _a.defaultValue, defaultValue = _s === void 0 ? null : _s, _t = _a.handleInputChange, handleInputChange = _t === void 0 ? constants_1.defaultFn : _t, _u = _a.onFocus, onFocus = _u === void 0 ? constants_1.defaultFn : _u, _v = _a.controlled, controlled = _v === void 0 ? false : _v, value = _a.value, _w = _a.enableSelectAll, enableSelectAll = _w === void 0 ? false : _w, _x = _a.showCountOfSelected, showCountOfSelected = _x === void 0 ? false : _x, _y = _a.countSelectedSuffix, countSelectedSuffix = _y === void 0 ? '' : _y, _z = _a.isDisabled, isDisabled = _z === void 0 ? false : _z, id = _a.id, _0 = _a.eventCallback, eventCallback = _0 === void 0 ? function () { return 0; } : _0, _1 = _a.showValueInControl, showValueInControl = _1 === void 0 ? false : _1, _2 = _a.showLabelInControl, showLabelInControl = _2 === void 0 ? false : _2, _3 = _a.controlColor, controlColor = _3 === void 0 ? {
        focused: colors_1.COLORS.ZAMP_PRIMARY,
        background: colors_1.COLORS.BASE_SECONDARY,
    } : _3, _4 = _a.tooltipBodyClassName, tooltipBodyClassName = _4 === void 0 ? '' : _4, _5 = _a.enableReset, enableReset = _5 === void 0 ? false : _5, _6 = _a.resetProps, resetProps = _6 === void 0 ? {
        resetClassName: '',
        resetTextClassName: '',
        resetText: 'Reset filters',
    } : _6, _7 = _a.size, size = _7 === void 0 ? dropdown_1.DROPDOWN_SIZE_TYPES.MEDIUM : _7, _8 = _a.countOfSelectedClassName, countOfSelectedClassName = _8 === void 0 ? 'f-16-300' : _8, _9 = _a.tooltipBody, tooltipBody = _9 === void 0 ? '' : _9;
    var valueRef = react_1.useRef(value);
    valueRef.current = value;
    var handleChange = function (selected, actionMeta) {
        var _a;
        var action = actionMeta.action, option = actionMeta.option, removedValue = actionMeta.removedValue;
        var updatedValue = [];
        if (action === ACTIONS.SELECT_OPTION && (option === null || option === void 0 ? void 0 : option.value) === SELECT_ALL_OPTION.value) {
            updatedValue = options;
        }
        else if ((action === ACTIONS.DESELECT_OPTION && (option === null || option === void 0 ? void 0 : option.value) === SELECT_ALL_OPTION.value) ||
            ((action === ACTIONS.REMOVE_VALUE || action === ACTIONS.POP_VALUE) &&
                (removedValue === null || removedValue === void 0 ? void 0 : removedValue.value) === SELECT_ALL_OPTION.value)) {
            updatedValue = [];
        }
        else if (action === ACTIONS.DESELECT_OPTION && isSelectAllSelected()) {
            updatedValue = options.filter(function (_a) {
                var value = _a.value;
                return value !== (option === null || option === void 0 ? void 0 : option.value);
            });
        }
        else {
            updatedValue = selected || [];
        }
        onChange === null || onChange === void 0 ? void 0 : onChange(updatedValue);
        eventCallback === null || eventCallback === void 0 ? void 0 : eventCallback(mixpanel_events_1.mixpanelEvents.DROPDOWN_CHANGE, {
            id: id,
            selectedValue: Array.isArray(updatedValue)
                ? updatedValue.map(function (each) { return each.value; })
                : JSON.stringify((_a = updatedValue) === null || _a === void 0 ? void 0 : _a.value),
        });
    };
    var onClickReset = function () {
        handleChange([], { action: 'clear', removedValues: [] });
    };
    var MultiValue = function (props) {
        var _a;
        var index = props.index, getValue = props.getValue;
        var value = getValue();
        var selectAll = ((_a = value === null || value === void 0 ? void 0 : value[0]) === null || _a === void 0 ? void 0 : _a.value) === SELECT_ALL_OPTION.value;
        return index === 0 ? (react_1.default.createElement(molecules_1.Tooltip, { tooltipBody: tooltipBody, position: constants_1.TooltipPositions.LEFT, color: colors_1.COLORS.TEXT_PRIMARY, disabled: !tooltipBody || value.length === 0, tooltipBodystyle: tooltipBodyClassName, id: id },
            react_1.default.createElement(atoms_1.Text, { textClass: countOfSelectedClassName, id: "dropdown-multi-value-" + id }, (selectAll ? options.length : value.length) + " " + countSelectedSuffix))) : (react_1.default.createElement("div", null));
    };
    var ValueContainer = function (props) {
        var children = props.children, getValue = props.getValue;
        var value = getValue();
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: 'tw-flex tw-justify-between tw-items-center tw-flex-1 tw-mr-2.5', "data-testid": "dropdown-value-" + id },
                react_1.default.createElement("div", { "data-testid": "dropdown-value-title-" + id }, labelProps === null || labelProps === void 0 ? void 0 : labelProps.title),
                showCountOfSelected && (react_1.default.createElement(molecules_1.Tooltip, { style: { right: '-34px' }, caratClassName: 'tw-border-b-TEXT_PRIMARY tw-left-[calc(100%-50px)]', position: constants_1.TooltipPositions.BOTTOM, disabled: value.length === 0, tooltipBody: react_1.default.createElement("div", { className: 'tw-flex tw-flex-col tw-gap-2' }, value === null || value === void 0 ? void 0 : value.map(function (item) { return (react_1.default.createElement("div", { key: item === null || item === void 0 ? void 0 : item.value, className: 'tw-whitespace-nowrap' }, item === null || item === void 0 ? void 0 : item.label)); })), tooltipBodystyle: "tw-text-white f-12-300 !tw-px-3 !tw-py-2 !tw-rounded " + tooltipBodyClassName, color: colors_1.COLORS.TEXT_PRIMARY, id: id }, !!value.length && (react_1.default.createElement("div", { className: 'tw-bg-BASE_PRIMARY f-10-600 tw-h-4 tw-w-5 tw-flex tw-items-center tw-justify-center', "data-testid": "dropdown-value-selected-count-" + id }, value.length))))),
            react_1.Children.toArray(children)[react_1.Children.count(children) - 1]));
    };
    var CustomMultiValueRemove = function (props) {
        return (react_1.default.createElement(react_select_1.components.MultiValueRemove, __assign({}, props),
            react_1.default.createElement(molecules_1.SvgSpriteLoader, { id: 'x-close', iconCategory: icons_1.ICON_SPRITE_TYPES.GENERAL, color: colors_1.COLORS.TEXT_TERTIARY, width: 16, height: 16 })));
    };
    var CustomSingleValue = function (props) {
        var data = props.data;
        var _a = data.spriteIcon, spriteIcon = _a === void 0 ? '' : _a, _b = data.icon, icon = _b === void 0 ? null : _b, _c = data.label, label = _c === void 0 ? '' : _c, _d = data.value, value = _d === void 0 ? '' : _d;
        return (react_1.default.createElement(react_select_1.components.SingleValue, __assign({}, props),
            react_1.default.createElement("div", { className: 'tw-flex tw-items-center', "data-testid": "dropdown-single-" + id },
                spriteIcon && (react_1.default.createElement("div", { className: 'tw-w-6 tw-mr-4', "data-testid": "dropdown-single-icon-" + id },
                    react_1.default.createElement(molecules_1.SvgSpriteLoader, { id: spriteIcon }))),
                !showValueInControl && icon,
                react_1.default.createElement("div", { className: DRODPWN_SIZE_STYLES[size].customClassNames.placeholder + " " + (customClassNames === null || customClassNames === void 0 ? void 0 : customClassNames.control), "data-testid": "dropdown-single-control-" + id }, showValueInControl ? value : label))));
    };
    var CustomOption = function (props) {
        var selectAllWrapperClass = "tw-p-2 tw-h-16 tw-flex tw-items-center tw-border-b tw-border-DIVIDER_GRAY";
        var data = props.data;
        return (react_1.default.createElement(react_select_1.components.Option, __assign({}, props),
            react_1.default.createElement(molecules_1.MenuOption, __assign({}, props, { isMulti: isMulti, contentWrapper: DRODPWN_SIZE_STYLES[size].menuOptionClasses.contentWrapper + " " + menuOptionClasses.contentWrapper, wrapperClass: ((data === null || data === void 0 ? void 0 : data.value) === SELECT_ALL_OPTION.value ? selectAllWrapperClass : '') + " " + DRODPWN_SIZE_STYLES[size].menuOptionClasses.wrapperClass + " " + menuOptionClasses.wrapperClass, containerClass: DRODPWN_SIZE_STYLES[size].menuOptionClasses.containerClass + " " + menuOptionClasses.containerClass, spriteSelectedIcon: spriteSelectedIcon, selectedIcon: selectedIcon, spriteSelectedIconColor: spriteSelectedIconColor, eventCallback: eventCallback, labelOverrideClassName: DRODPWN_SIZE_STYLES[size].menuOptionClasses.labelOverrideClassName + " " + menuOptionClasses.labelOverrideClassName }))));
    };
    var MenuList = function (props) {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(react_select_1.components.MenuList, __assign({}, props), props.children),
            react_1.default.createElement("div", { className: "tw-flex tw-py-3 tw-pl-4 tw-border-t tw-border-DIVIDER_GRAY " + (resetProps === null || resetProps === void 0 ? void 0 : resetProps.resetClassName), onClick: onClickReset, "data-testid": "dropdown-reset-" + id },
                react_1.default.createElement(molecules_1.SvgSpriteLoader, { id: 'refresh-ccw-01', iconCategory: icons_1.ICON_SPRITE_TYPES.ARROWS, height: 14, width: 14, color: colors_1.COLORS.TEXT_PRIMARY }),
                react_1.default.createElement("div", { className: "tw-pl-2 f-12-400 tw-text-TEXT_PRIMARY " + (resetProps === null || resetProps === void 0 ? void 0 : resetProps.resetTextClassName), "data-testid": "dropdown-reset-title-" + id }, resetProps === null || resetProps === void 0 ? void 0 : resetProps.resetText))));
    };
    var addSelectAllInOptions = function () { return __spreadArray([SELECT_ALL_OPTION], options); };
    var isSelectAllSelected = function () { var _a; return Array.isArray(valueRef === null || valueRef === void 0 ? void 0 : valueRef.current) && ((_a = valueRef === null || valueRef === void 0 ? void 0 : valueRef.current) === null || _a === void 0 ? void 0 : _a.length) === options.length; };
    var getValue = function () { return (enableSelectAll && isSelectAllSelected() ? [SELECT_ALL_OPTION] : value); };
    var isOptionSelected = function (option) {
        var _a;
        return (Array.isArray(valueRef === null || valueRef === void 0 ? void 0 : valueRef.current) && ((_a = valueRef === null || valueRef === void 0 ? void 0 : valueRef.current) === null || _a === void 0 ? void 0 : _a.some(function (_a) {
            var value = _a.value;
            return value === option.value;
        }))) ||
            isSelectAllSelected();
    };
    return (react_1.default.createElement("div", { className: wrapperClass, "data-testid": "dropdown-" + id },
        showLabel && react_1.default.createElement(molecules_1.Label, __assign({}, labelProps, { id: "dropdown-label-" + id })),
        react_1.default.createElement("div", { className: selectFieldWrapperClass, "data-testid": "select-wrapper-" + id },
            react_1.default.createElement(react_select_1.default, __assign({ name: 'select', options: enableSelectAll ? addSelectAllInOptions() : options, defaultValue: defaultValue, isMulti: isMulti, placeholder: placeholder, menuPosition: 'absolute', noOptionsMessage: function () { return noOptionsText; }, closeMenuOnSelect: !isMulti, hideSelectedOptions: false, components: __assign(__assign({ Option: CustomOption, DropdownIndicator: CustomDropdownIndicator, MultiValueRemove: CustomMultiValueRemove, SingleValue: CustomSingleValue }, (enableReset ? { MenuList: MenuList } : {})), (showLabelInControl ? { ValueContainer: ValueContainer } : showCountOfSelected ? { MultiValue: MultiValue } : {})), styles: {
                    option: function (styles, data) { return (__assign(__assign(__assign(__assign({}, styles), { padding: 0, borderRadius: '10px', backgroundColor: (data === null || data === void 0 ? void 0 : data.isFocused) ? colors_1.COLORS.BASE_SECONDARY : 'white' }), DRODPWN_SIZE_STYLES[size].customStyles.option), customStyles === null || customStyles === void 0 ? void 0 : customStyles.option)); },
                    indicatorSeparator: function () { return (__assign({ appearance: 'none' }, customStyles === null || customStyles === void 0 ? void 0 : customStyles.indicatorSeparator)); },
                    dropdownIndicator: function (styles) { return (__assign(__assign(__assign({}, styles), { padding: 0 }), customStyles === null || customStyles === void 0 ? void 0 : customStyles.dropdownIndicator)); },
                    menu: function (styles) { return (__assign(__assign(__assign(__assign({}, styles), { boxShadow: '1px 2px 10px rgba(197, 220, 255, 0.54)', cursor: 'pointer' }), DRODPWN_SIZE_STYLES[size].customStyles.menu), customStyles === null || customStyles === void 0 ? void 0 : customStyles.menu)); },
                    input: function (styles) { return (__assign(__assign(__assign(__assign({}, styles), { 'input:focus': {
                            boxShadow: 'none',
                        }, margin: 0, padding: 0 }), DRODPWN_SIZE_STYLES[size].customStyles.input), customStyles === null || customStyles === void 0 ? void 0 : customStyles.input)); },
                    control: function (styles, data) { return (__assign(__assign(__assign(__assign({}, styles), { backgroundColor: isDisabled ? colors_1.COLORS.BASE_PRIMARY : controlColor.background, borderWidth: '1px', borderColor: error ? errorColor : (data === null || data === void 0 ? void 0 : data.isFocused) ? controlColor.focused : colors_1.COLORS.DIVIDER_GRAY, boxShadow: '0px 0px', ':hover': {
                            borderColor: controlColor.focused,
                        } }), DRODPWN_SIZE_STYLES[size].customStyles.control), customStyles === null || customStyles === void 0 ? void 0 : customStyles.control)); },
                    multiValue: function (styles) { return (__assign(__assign({}, (showCountOfSelected
                        ? {}
                        : __assign(__assign({}, styles), { backgroundColor: colors_1.COLORS.ZAMP_SECONDARY, borderRadius: '28px', padding: '4px 8px 4px 3px', height: '24px', display: 'flex', alignItems: 'center', margin: '2px 8px 2px 0px' }))), customStyles === null || customStyles === void 0 ? void 0 : customStyles.multiValue)); },
                    multiValueLabel: function (styles) { return (__assign(__assign(__assign({}, styles), { color: colors_1.COLORS.TEXT_SECONDARY, padding: 0, fontSize: '12px', fontWeight: 300, lineHeight: '16px' }), customStyles === null || customStyles === void 0 ? void 0 : customStyles.multiValueLabel)); },
                    multiValueRemove: function (styles) { return (__assign(__assign(__assign({}, styles), { padding: 0, height: '16px', ':hover': {
                            backgroundColor: colors_1.COLORS.ZAMP_SECONDARY,
                        } }), customStyles === null || customStyles === void 0 ? void 0 : customStyles.multiValueRemove)); },
                    singleValue: function (styles) { return (__assign(__assign(__assign({}, styles), { margin: 0 }), customStyles === null || customStyles === void 0 ? void 0 : customStyles.singleValue)); },
                    valueContainer: function (styles) { return (__assign(__assign(__assign(__assign({}, styles), { padding: 0, minHeight: '28px' }), DRODPWN_SIZE_STYLES[size].customStyles.valueContainer), customStyles === null || customStyles === void 0 ? void 0 : customStyles.valueContainer)); },
                    placeholder: function (styles) { return (__assign(__assign(__assign({}, styles), { marginLeft: 0, color: colors_1.COLORS.TEXT_TERTIARY }), customStyles === null || customStyles === void 0 ? void 0 : customStyles.placeholder)); },
                    menuList: function (styles) { return (__assign(__assign(__assign({}, styles), { padding: 0 }), customStyles === null || customStyles === void 0 ? void 0 : customStyles.menuList)); },
                    noOptionsMessage: function (styles) { return (__assign(__assign(__assign({}, styles), { color: colors_1.COLORS.TEXT_TERTIARY }), customStyles === null || customStyles === void 0 ? void 0 : customStyles.noOptionsMessage)); },
                    groupHeading: function (styles) { return (__assign(__assign({}, styles), { color: colors_1.COLORS.TEXT_TERTIARY, padding: '16px 24px', fontSize: '13px' })); },
                    container: function (styles) { return (__assign(__assign({}, styles), customStyles === null || customStyles === void 0 ? void 0 : customStyles.container)); },
                }, classNames: {
                    placeholder: function () { var _a; return "" + ((_a = customClassNames === null || customClassNames === void 0 ? void 0 : customClassNames.placeholder) !== null && _a !== void 0 ? _a : DRODPWN_SIZE_STYLES[size].customClassNames.placeholder); },
                    menu: function () { var _a; return "" + ((_a = customClassNames === null || customClassNames === void 0 ? void 0 : customClassNames.menu) !== null && _a !== void 0 ? _a : "tw-bg-white tw-border-[0.5px] tw-border-DIVIDER_GRAY"); },
                    noOptionsMessage: function () { var _a; return "" + ((_a = customClassNames === null || customClassNames === void 0 ? void 0 : customClassNames.noOptionsMessage) !== null && _a !== void 0 ? _a : "tw-h-16 tw-flex tw-items-center tw-justify-center"); },
                }, onChange: handleChange, isClearable: false, isDisabled: isDisabled, isSearchable: isSearchable, onInputChange: handleInputChange, onFocus: onFocus, menuPlacement: 'auto' }, (enableSelectAll ? { isOptionSelected: isOptionSelected } : {}), (controlled ? { value: getValue() } : {}), { 
                // @ts-ignore selectProps contains all props passed to react select. It's passed to each child component of react-select and takes custom props as well.
                size: size }))),
        showSupporterInfo && react_1.default.createElement(molecules_1.SupporterInfo, __assign({}, supporterInfoProps, { id: id }))));
};
exports.Dropdown = Dropdown;
